/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'
import Carousel from '../components/big/Carousel'
import ProductCarousel from '../components/big/ProductCarousel'
import Layout from '../components/Layout'
import Banners from '../models/bennerModels'
import Filters from '../models/filtersModel'
import Titles from '../models/titleModel'
import { convertDocToObj, getAllProductData, getRelasisByJenis } from '../utils/serverSideFetch'
import CarouselMobile from '../components/big/CarouselMobile'
import connectDB from '../utils/connectDB'
import Products from '../models/productModel'

const produk = ({titleData,productData,dataOrmas,filters,bannerDataPc,bannerDataMobile,secondProduct}) => {

	const [second, setSecond] = useState(false);


  return (
    <Layout titlePage={'produk'} titleData={titleData} dataOrmas={dataOrmas}>
<Carousel bannerDataPc={bannerDataPc}/>
<CarouselMobile bannerDataMobile={bannerDataMobile}/>

      <section className='bg-white overflow-hidden keAtas'>
      <div className="px-5 mt-4" style={{minHeight: 450}}>
          <h2 className='text-center text-black'>
              Sesuai kan kemasan produk dengan kebutuhan Anda
          </h2>
        <ProductCarousel productData={productData}/>


		<p className='text-primary mt-5' onClick={() => setSecond(!second)}  style={{ cursor: 'pointer'}}>{second ? (`Sembunyikan Produk lainya ${titleData.judulFooter} ...!`) : (`Tampilkan Produk lainya di ${titleData.judulFooter} ...!`)} </p>
        
    </div>

	{second ?  (
		<div className="px-5" style={{minHeight: 450}}>
          <h2 className='text-center text-black'>
              Second Produk Lainya di {titleData.judulFooter} :
          </h2>
        <ProductCarousel productData={secondProduct}/>

        
    </div>
	) : (
		null
	)}

	

    <div className="container mb-5">
	<div className="row justify-content-center">
		<div className="col-md-6">
			<h4 className='text-black'>Kebijakan <i> {titleData.judulFooter}</i> dalam Mengelolah PRODUK:</h4>
			<ul className="timeline">
				{filters.map(filter => (
				<li key={filter._id}>
					<h2 className='text-black'>{filter.name}</h2>
					<p className='text-black'>{filter.deskripsi}</p>
				</li>
				))}
				

			</ul>
		</div>
	</div>
</div>
      </section>
    
    </Layout>
  )
}

export default produk

export async function getStaticProps(context) {

	const productData = await getAllProductData();

	connectDB();
	const secondProduct = await Products.find({priority : 'second'}).lean();

	const filters = await Filters.find({tipe: "produk"}).lean();

	const titleData = await Titles.findOne({_id:'6301dbdb8e6ecc04f372e7fb'}).lean();
	const dataOrmas = await getRelasisByJenis('ormas');
	const bannerDataPc = await Banners.find({halamanBanner : "produk",tipeBanner : "pc"}).lean();
	const bannerDataPcCount = await Banners.find({halamanBanner : "produk",tipeBanner : "pc"}).count();
	const bannerDataMobile = await Banners.find({halamanBanner : "produk",tipeBanner : "mobile"}).lean();
	const bannerDataMobileCount = await Banners.find({halamanBanner : "produk",tipeBanner : "mobile"}).count();
  
	return {
	  props: {titleData : convertDocToObj(titleData),dataOrmas : dataOrmas.map(o => convertDocToObj(o)),productData : productData.map(p => convertDocToObj(p)),
		filters : filters.map(f => convertDocToObj(f)),
		
		bannerDataPc: bannerDataPc.map(bp => convertDocToObj(bp)),count: bannerDataPcCount,
		bannerDataMobile: bannerDataMobile.map(bm => convertDocToObj(bm)),count: bannerDataMobileCount,
		secondProduct : secondProduct.map(sec => convertDocToObj(sec))
	}, 
	revalidate: 30,
	}
  }

